import styles from './styles.module.scss'

const Accordion = ({ title, children, id, customClass }) => {
  return (
    <details
      data-animate="fade-up"
      className={`${styles.details} ${customClass} animate-init`}
    >
      <summary id={id} className={styles.summary}>
        {title}

        <div className={styles.icon}>
          <div data-action="close" className={styles.iconY} />
          <div data-action="open" className={styles.iconX} />
        </div>
      </summary>
      <div className={styles.container}>
        <div className={styles.content}>{children}</div>
      </div>
    </details>
  )
}

export default Accordion
